export default __webpack_public_path__ + "static/media/1.9e0407ec.webp";